import { api } from '../../api/api';

// initial state
const state = {
   recs:null,
   loaded:null
};

// getters
const getters = {
};

// actions
const actions = {
   FEATURES_SET:(context, {features})=>{
      return new Promise((resolve, reject)=>{
         if (!features) return resolve();

         context.commit('FEATURES_RECS_SET', {recs: features});
         context.commit('FEATURES_LOADED', {loaded: true});
         resolve();
      });
   }
};

// mutations
const mutations = {
   FEATURES_RECS_SET:(state,{recs})=>{
      state.recs = recs;
   },
   FEATURES_LOADED:(state,{loaded})=>{
      state.loaded = loaded;
   },
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/feature.js